import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'inputType'
})
export class InputTypePipe implements PipeTransform {

  transform(value:any) {
    if(value){
      return value.display_type;
    }else{
      return 'text';
    }
    
  }
}